module.exports = __webpack_public_path__ + "static/img/product3.42255b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/white/product3.png
// module id = fHmn
// module chunks = 0